/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for financial channel permission
 * @export
 * @interface FinancialChannelPermissionRequest
 */
export interface FinancialChannelPermissionRequest {
    /**
     * Unique identifier of the planning permission
     * @type {string}
     * @memberof FinancialChannelPermissionRequest
     */
    id?: string;
    /**
     * Unique identifier of the person
     * @type {string}
     * @memberof FinancialChannelPermissionRequest
     */
    personId?: string;
    /**
     * Firstname and lastname of the person
     * @type {string}
     * @memberof FinancialChannelPermissionRequest
     */
    name?: string;
    /**
     * True if the person is allowed to access financial channel
     * @type {boolean}
     * @memberof FinancialChannelPermissionRequest
     */
    allowed?: boolean;
}

/**
 * Check if a given object implements the FinancialChannelPermissionRequest interface.
 */
export function instanceOfFinancialChannelPermissionRequest(value: object): value is FinancialChannelPermissionRequest {
    return true;
}

export function FinancialChannelPermissionRequestFromJSON(json: any): FinancialChannelPermissionRequest {
    return FinancialChannelPermissionRequestFromJSONTyped(json, false);
}

export function FinancialChannelPermissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialChannelPermissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'name': json['name'] == null ? undefined : json['name'],
        'allowed': json['allowed'] == null ? undefined : json['allowed'],
    };
}

export function FinancialChannelPermissionRequestToJSON(json: any): FinancialChannelPermissionRequest {
    return FinancialChannelPermissionRequestToJSONTyped(json, false);
}

export function FinancialChannelPermissionRequestToJSONTyped(value?: FinancialChannelPermissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'name': value['name'],
        'allowed': value['allowed'],
    };
}

